export const FETCH_CALENDAR = 'Profile/FetchCalendar';

export const PROFILE_SAVECALENDAR = 'Profile/SaveCalendar';

export const PROFILE_FETCHPROFILEDETAILS = 'Profile/FetchProfileDetails';

export const PROFILE_SAVECONTACT = 'Profile/SaveContacts';

export const INVENTORY_FETCH_DOCTORS = 'Inventory/FetchDoctors';

export const INVENTORY_SAVE_DOCTORS = 'Inventory/SaveDoctors';

export const DOCTORS_DEPARTMENTS = 'Custom/FetchDoctorDepartment';

export const DOCTORS_QUALIFICATIONS = 'Custom/FetchQualification/';

export const FETCH_INVESTIGATIONS = 'Custom/FetchInvestigations';

export const INVENTORY_SAVE_HEALTHCHECK = 'Inventory/SaveHCPackage';

export const FETCH_CINSULTATION = 'Custom/SearchLookUp/ConsultationType';
export const INVENTORY_FETCH_IP_PACKAGE = 'Inventory/FetchInPatientPackage';
export const PROFILE_FETCH_ROOMS = 'Profile/FetchRooms';
export const INVENTORY_SAVE_IP_PACKAGE = 'Inventory/SaveIPPackage';
export const INCLUSION_TYPE_INPATIENT = 'Custom/SearchLookUp/InclusionType_InPatient';
export const FETCH_INPATIENT_PROCEDURE_LIST = 'Inventory/FetchProcedureList/InPatient/';
export const DEPARTMENT_INPATIENT = 'Custom/FetchDepartment/InPatient';
export const DEPARTMENT_DAYCARE = 'Custom/FetchDepartment/DayCare';
export const INCLUSION_TYPE_DAYCARE = 'Custom/SearchLookUp/InclusionType_DayCare';
export const FETCH_DAYCARE_PROCEDURE_LIST = 'Inventory/FetchProcedureList/DayCare/';
export const INVENTORY_SAVE_LABTEST = 'Inventory/SaveLabTest';
export const FETCH_DASHBOARD = 'Dashboard/FetchDashboard';
export const SAVE_ROOMS = 'Profile/SaveRooms';
export const FETCH_ROOM_TYPES = 'Custom/SearchLookUp/RoomType';
export const FETCH_AMENITY_LIST = 'Custom/SearchLookUp/AmenityType';
export const FETCH_INVENTORY_DASHBOARD = 'FetchInventoryDashBoard';
export const IHXCHECK_USER_DETAILS = 'UserDetails';
export const DASHBOARD_POWER_BI = 'Dashboard/PowerBi';
export const DASHBOARD_PDF_DOWNLOAD = 'Dashboard/PowerBiDownload';
export const DEPARTMENT_HC = 'Custom/FetchDepartment/HealthCheck';
export const INVENTORY_MASTER_PACKAGE_MAPPING = 'Inventory/FetchPackageMasterMapping';
